import { render, staticRenderFns } from "./tieDetail.vue?vue&type=template&id=68de4222&scoped=true&"
import script from "./tieDetail.vue?vue&type=script&lang=js&"
export * from "./tieDetail.vue?vue&type=script&lang=js&"
import style0 from "./tieDetail.vue?vue&type=style&index=0&id=68de4222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68de4222",
  null
  
)

export default component.exports